import { Injectable, inject } from "@angular/core";
import { LgLocalizationSettings } from "@logex/framework/lg-localization";
import { LgLoaderService } from "@logex/framework/lg-layout";
import { UserSettingsService, WellKnownSettingCode } from "@logex/framework/lg-application";
import { Dictionary } from "lodash";
import { lastValueFrom } from "rxjs";

@Injectable()
export class AppLgLocalizationSettings implements LgLocalizationSettings {
    private _lgLoaderService = inject(LgLoaderService);
    private _userSettingsService = inject(UserSettingsService);

    constructor() {
        this.languages = {};

        this.bootstrapDone = new Promise(resolve => {
            this.setReady = resolve;
        });
    }

    setStrings(lang: string, strings: Dictionary<any>): void {
        throw new Error("Method not implemented.");
    }

    // ----------------------------------------------------------------------------------

    availableLanguages: string[];
    fallbackLanguage: string;
    languages: _.Dictionary<any[]>;
    preferredLanguage: string;
    locale: string;
    currency: string;
    bootstrapDone: Promise<void>;

    setReady: () => void;

    // ----------------------------------------------------------------------------------

    setPreferredLanguage(lang: string): void {
        this.preferredLanguage = lang;
    }

    addStrings(lang: string, strings: _.Dictionary<any>): void {
        if (!this.languages[lang]) this.languages[lang] = [];
        this.languages[lang].push(strings);
    }

    async switchCurrentLanguage(lang: string): Promise<void> {
        this._lgLoaderService.show();

        await lastValueFrom(
            this._userSettingsService.set({
                key: { storageId: WellKnownSettingCode.uiSettings },
                value: { language: lang }
            })
        );

        window.location.reload();
    }
}
